export default __webpack_public_path__ + "static/media/disable-process-three.83717c3a.svg";